import { Buffer } from "buffer";
import Process from "process";

window.global ||= window;
globalThis.Buffer = Buffer;
globalThis.process = Process;
// globalThis.require = Require;